module.exports = __webpack_public_path__ + "static/media/celebration-memoji.be9a72b2.png";